<section id="section-grid" class="container m-t-40">
  <div class="simple-card">
    <p class="h2 p-tb-12 border-bottom m-b-0">Grid</p>

    <div class="grids m-t-20">
      <div class="row">
        <div class="col-12">
          <div class="bg-card-grid d-flex" style="height: 30px; padding: 4px">.col-12</div>
        </div>
      </div>

      <div class="row m-t-20">
        <div class="col-1">
          <div class="bg-card-grid d-flex" style="height: 30px; padding: 4px">.col-1</div>
        </div>
        <div class="col-1">
          <div class="bg-card-grid d-flex" style="height: 30px; padding: 4px">.col-1</div>
        </div>
        <div class="col-1">
          <div class="bg-card-grid d-flex" style="height: 30px; padding: 4px">.col-1</div>
        </div>
        <div class="col-1">
          <div class="bg-card-grid d-flex" style="height: 30px; padding: 4px">.col-1</div>
        </div>
        <div class="col-1">
          <div class="bg-card-grid d-flex" style="height: 30px; padding: 4px">.col-1</div>
        </div>
        <div class="col-1">
          <div class="bg-card-grid d-flex" style="height: 30px; padding: 4px">.col-1</div>
        </div>
        <div class="col-1">
          <div class="bg-card-grid d-flex" style="height: 30px; padding: 4px">.col-1</div>
        </div>
        <div class="col-1">
          <div class="bg-card-grid d-flex" style="height: 30px; padding: 4px">.col-1</div>
        </div>
        <div class="col-1">
          <div class="bg-card-grid d-flex" style="height: 30px; padding: 4px">.col-1</div>
        </div>
        <div class="col-1">
          <div class="bg-card-grid d-flex" style="height: 30px; padding: 4px">.col-1</div>
        </div>
        <div class="col-1">
          <div class="bg-card-grid d-flex" style="height: 30px; padding: 4px">.col-1</div>
        </div>
        <div class="col-1">
          <div class="bg-card-grid d-flex" style="height: 30px; padding: 4px">.col-1</div>
        </div>
      </div>

      <div class="row m-t-20">
        <div class="col-2">
          <div class="bg-card-grid" style="height: 30px; padding: 4px">.col-2</div>
        </div>
        <div class="col-2">
          <div class="bg-card-grid" style="height: 30px; padding: 4px">.col-2</div>
        </div>
        <div class="col-2">
          <div class="bg-card-grid" style="height: 30px; padding: 4px">.col-2</div>
        </div>
        <div class="col-2">
          <div class="bg-card-grid" style="height: 30px; padding: 4px">.col-2</div>
        </div>
        <div class="col-2">
          <div class="bg-card-grid" style="height: 30px; padding: 4px">.col-2</div>
        </div>
        <div class="col-2">
          <div class="bg-card-grid" style="height: 30px; padding: 4px">.col-2</div>
        </div>
      </div>

      <div class="row m-t-20">
        <div class="col-4">
          <div class="bg-card-grid" style="height: 30px; padding: 4px">.col-4</div>
        </div>
        <div class="col-4">
          <div class="bg-card-grid" style="height: 30px; padding: 4px">.col-4</div>
        </div>
        <div class="col-4">
          <div class="bg-card-grid" style="height: 30px; padding: 4px">.col-4</div>
        </div>
      </div>

      <div class="row m-t-20">
        <div class="col-6">
          <div class="bg-card-grid" style="height: 30px; padding: 4px">.col-6</div>
        </div>

        <div class="col-6">
          <div class="bg-card-grid" style="height: 30px; padding: 4px">.col-6</div>
        </div>
      </div>

      <div class="row m-t-20">
        <div class="col-3">
          <div class="bg-card-grid" style="height: 30px; padding: 4px">.col-3</div>
        </div>

        <div class="col-5">
          <div class="bg-card-grid" style="height: 30px; padding: 4px">.col-5</div>
        </div>

        <div class="col-4">
          <div class="bg-card-grid" style="height: 30px; padding: 4px">.col-4</div>
        </div>
      </div>

      <div class="row m-t-20">
        <div class="col-7">
          <div class="bg-card-grid" style="height: 30px; padding: 4px">.col-7</div>
        </div>

        <div class="col-5">
          <div class="bg-card-grid" style="height: 30px; padding: 4px">.col-5</div>
        </div>
      </div>

      <div class="row m-t-20">
        <div class="col-8">
          <div class="bg-card-grid" style="height: 30px; padding: 4px">.col-8</div>
        </div>

        <div class="col-4">
          <div class="bg-card-grid" style="height: 30px; padding: 4px">.col-4</div>
        </div>
      </div>

      <div class="row m-t-20">
        <div class="col-9">
          <div class="bg-card-grid" style="height: 30px; padding: 4px">.col-9</div>
        </div>

        <div class="col-3">
          <div class="bg-card-grid" style="height: 30px; padding: 4px">.col-3</div>
        </div>
      </div>

      <div class="row m-t-20">
        <div class="col-10">
          <div class="bg-card-grid" style="height: 30px; padding: 4px">.col-10</div>
        </div>

        <div class="col-2">
          <div class="bg-card-grid" style="height: 30px; padding: 4px">.col-2</div>
        </div>
      </div>

      <div class="row m-t-20">
        <div class="col-11">
          <div class="bg-card-grid" style="height: 30px; padding: 4px">.col-11</div>
        </div>

        <div class="col-1">
          <div class="bg-card-grid" style="height: 30px; padding: 4px">.col-1</div>
        </div>
      </div>
    </div>
  </div>
</section>

<div class="simple-card m-t-40">
  <section class="">
    <div class="container">
      <p class="h2 p-tb-12 border-bottom m-b-0">Container</p>
    </div>

    <div class="container m-t-20">
      <div class="border text-center">.container</div>
    </div>
  </section>

  <div class="container-fluid m-t-20">
    <div class="border text-center">.container-fluid</div>
  </div>

  <section>
    <div class="w-100 m-t-20">
      <div class="border text-center">.w-100 (Wide)</div>
    </div>
  </section>
</div>
